<sales-ui-meddic-section
  [accountGroupId]="opportunity?.accountGroupId"
  [opportunityId]="opportunity?.opportunityId"
  [fallbackSalespersonId]="opportunity?.salesPersonId || ''"
/>
